<template>
  <div class="container">
    <div class="bg">
      <NavBar
        class="nav-bar"
        :options="options"
        :placeholder="true"
        title="传播记录"
        :zIndex="10"
      >
      </NavBar>
      <div v-if="loaded">
        <div class="content">
          <div class="title">我的奖励</div>
          <div class="prize-container">
            <div class="prize-list" v-if="prizeData.num">
              <div
                class="prize-item"
                v-for="(item, index) in prizeData.list"
                :key="index"
              >
                <img class="image" :src="item.detail_img" alt="" />
                <div class="center">
                  <span class="name">{{ item.prize_name }}</span>
                  <span class="unit">x {{ prizeData.num }}</span>
                </div>
                <div class="btn" @click="bindUse">查看</div>
              </div>
            </div>
            <div
              v-if="!prizeData || !prizeData.num || !prizeData.list.length"
              class="not-data"
              >暂无奖励</div
            >
          </div>
          <!--  -->
          <div class="title">传播明细</div>
          <div class="invite-list" v-if="inviteList.length">
            <div
              class="invite-item"
              v-for="(item, index) in inviteList"
              :key="index"
            >
              <div class="item-top">
                <img
                  class="avatar"
                  :src="item.head_img || defaultAvatar"
                  alt=""
                />
                <div class="name">{{ item.truename }}（{{ item.phone }}）</div>
              </div>
              <div class="step-list">
                <div
                  class="step-item"
                  :class="{ 'step-item-active': item.state >= index1 }"
                  v-for="(item1, index1) in statusList"
                  :key="index1"
                >
                  <div class="line top-line" v-if="index1 != 0"></div>
                  <div class="item-flex">
                    <div class="dot iconfont icon-gou"></div>
                    <div class="status">{{ item1.title }}</div>
                    <div class="item-time">{{ item[item1.param] }}</div>
                  </div>
                  <div
                    class="line bottom-line"
                    v-if="index1 != statusList.length - 1"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="not-data">暂无邀请记录</div>
        </div>
        <img
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          class="logo"
          alt=""
        />
      </div>
      <van-loading
        class="v-loading"
        v-else
        text-color="#888888"
        color="#888888"
        vertical
        >加载中...</van-loading
      >
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    NavBar
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent',
        color: '#000'
      },
      defaultAvatar:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/949fe511a67a706a851fcbd3b1a8cc5a.png',
      loaded: false,
      statusList: [
        {
          title: '已领取',
          param: 'time'
        },
        {
          title: '已登录',
          param: 'loginTime'
        }
      ],
      prizeData: {
        num: 0,
        list: []
      }, //我的奖品列表
      inviteList: [] //邀请进度列表
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.addScroll()
  },

  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    getData() {
      let params = {
        invitation_id: this.$route.query.inviteId,
        activity_id: this.$route.query.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/getSpeed', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.inviteList = res.data.list || []
            if (res.data.prize_list) {
              let data = res.data.prize_list
              data.list.map((item) => {
                item.detail_img =
                  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/139f66529f3bc8282c0294a3d075dc6d.png'
              })
              this.prizeData = res.data.prize_list || {}
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    /**
     * 使用奖励
     */
    bindUse() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageRoute({
          path: 'miniProgram', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'userName', value: 'gh_22053f67c0f7' },
            { key: 'path', value: 'cms_design/usercenter' }
          ]
        })
      }
    },
    bindClose() {
      this.showPoster = false
    },
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
}
.bg {
  width: 100%;
  min-height: 100vh;
  padding: 32px 25px 24px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
  background: #e1d8ff;
}
.content {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  padding: 18px 24px 18px;
  margin-bottom: 260px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
    font-weight: 600;
    color: #55417a;
    line-height: 22px;
    margin-bottom: 10px;
  }
  .prize-container {
    margin-bottom: 10px;
  }
  .prize-list {
    .prize-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #55417a;
      background-color: #fff;
      line-height: 20px;
      padding: 7px 18px 7px 11px;
      box-sizing: border-box;
      border-radius: 16px;
      margin-bottom: 10px;
      .image {
        width: 44px;
        height: 44px;
        margin-right: 7px;
        object-fit: contain;
      }
      .center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;
        display: flex;
        align-items: center;
        .name {
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 10px;
        }
        .unit {
          white-space: nowrap;
        }
      }
      .btn {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #6236ff;
        line-height: 20px;
      }
    }
    .prize-item:last-child {
      margin-bottom: 0px;
    }
  }
  .not-data {
    text-align: center;
    font-size: 14px;
    height: 144px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.6);
  }
  .invite-list {
    .invite-item {
      padding: 17px 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 16px;
      .item-top {
        display: flex;
        align-items: center;
        margin-bottom: 17px;
        .avatar {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
        }
        .name {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #55417a;
          line-height: 20px;
        }
      }
      .step-list {
        padding-left: 33px;
        .step-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .line {
            margin-left: 8px;
            width: 4px;
            height: 13px;
            background: #e8e8e8;
          }
          .item-flex {
            display: flex;
            align-items: center;
            .dot {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #e8e8e8;
              margin-right: 11px;
              color: transparent;
              font-size: 12px;
            }
            .status {
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
              line-height: 20px;
              margin-right: 10px;
            }
            .item-time {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #55417a;
              line-height: 14px;
            }
          }
        }
        .step-item-active {
          .line {
            background-color: #6236ff;
          }
          .item-flex {
            .dot {
              background-color: #6236ff;
              color: #fff;
            }
            .status {
              color: #55417a;
            }
          }
        }
      }
    }
  }
}
.logo {
  margin: 0 auto;
  height: 18px;
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
}
</style>
